import { useFeatureFlagEnabled } from 'posthog-js/react';

import { useGetWidgetSettings } from 'hooks/customization';
import { useAuth } from 'shared/lib/auth/useAuth';
import { FeatureFlag } from 'shared/lib/features/common';

import { getVisibleNotificationCategories } from './helpers';

export const useHasVisibleNotifications = (): boolean => {
  const isKnockNotificationsEnabled = useFeatureFlagEnabled(FeatureFlag.KNOCK_NOTIFICATIONS);
  const { permissions } = useAuth();
  const { data: widgetSettings } = useGetWidgetSettings();

  if (!isKnockNotificationsEnabled) {
    return false;
  }

  const visibleCategories = getVisibleNotificationCategories(permissions, widgetSettings?.use_case);
  return visibleCategories.length > 0;
};
